import { FC, useEffect, useState } from "react";
import "../../App.css";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import { Feature } from "ol";
import { fromLonLat } from "ol/proj";
import { Geometry, Point } from "ol/geom";
import { map } from "../../mainLayer/MainLayer";
import Overlay from "ol/Overlay.js";
import ReactDOM from "react-dom";
import Style from "ol/style/Style";
import Icon from "ol/style/Icon";
import { Coordinate } from "ol/coordinate";
import { getLayerName } from "../../TimeLine/MainTimeLineVisible";
import styles from "../../initial/layersPopup/Menu.module.css";
import EarlyWarningPopup from "./EarlyWarningPopup";
import GeoJSON from "ol/format/GeoJSON.js";
import EWSLayerAdd from "./EWSLayerAdd";
import {
  layerButtonValue,
  openWindowsMapRiver,
  riverMap,
} from "../../../src/riverSensors/RiverSensors";
import { useEWSContext } from "../../provider/EWSProvider";
import { useAllWeatherContext } from "../../provider/AllWeatherProvider";
import {
  airQualityMap,
  openWindowsAirQualityMap,
} from "../airQuality/airQuality";
import {
  HzSidebarMap,
  openWindowsHzMap,
} from "../hazardIncidentsLayers/IncidentsMenuDropDown";
import { openWindowsRainfallMap, rainfallMap } from "../rainfall/Rainfall";

export interface earlyWarning {
  w_id: string;
  active_pcode: string;
  lat: number;
  lon: number;
  adm4_en: string;
  end_time: string;
  s_desc: string;
  severity_index: string;
  issued_time: string;
  severity: string;
  w_status: string;
  w_desc: string;
  w_name: string;
  w_type: string;
  adm4_pcode: string;
  adm3_pcode: string;
  adm3_en: string;
  adm2_pcode: string;
  adm2_en: string;
  active_alevel: string;
  en_desc: string;
  validityPeriod: string;
  adm1_en: string;
}

interface EwsSidebar {
  sensorId: string | null;
  coordinates: Coordinate | null;
  adm4_en: string | null;
  active_pcode: string | null;
  end_time: string | null;
  s_desc: string | null;
  severity_index: string | null;
  severity: string | null;
  adm4_pcode: string | null;
  adm3_pcode: string | null;
  adm3_en: string | null;
  adm2_pcode: string | null;
  adm2_en: string | null;
  active_alevel: string | null;
  en_desc: string | null;
  validityPeriod: string | null;
  issued_time: string | null;
  w_status: string | null;
  w_desc: string | null;
  w_name: string | null;
  w_type: string | null;
  adm1_en: string | null;
}

const amberFlood = new Style({
  image: new Icon({
    anchor: [0.5, 1],
    src: "assets/af.png",
    scale: 0.3,
  }),
});

const amberRain = new Style({
  image: new Icon({
    anchor: [0.5, 1],
    src: "assets/ah.png",
    scale: 0.3,
  }),
});

const amberLandslides = new Style({
  image: new Icon({
    anchor: [0.5, 1],
    src: "assets/al.png",
    scale: 0.3,
  }),
});

const amberLighting = new Style({
  image: new Icon({
    anchor: [0.5, 1],
    src: "assets/alh.png",
    scale: 0.3,
  }),
});

const amberMarine = new Style({
  image: new Icon({
    anchor: [0.5, 1],
    src: "assets/am.png",
    scale: 0.3,
  }),
});

const amberWind = new Style({
  image: new Icon({
    anchor: [0.5, 1],
    src: "assets/aw.png",
    scale: 0.3,
  }),
});

const evaquationFlood = new Style({
  image: new Icon({
    anchor: [0.5, 1],
    src: "assets/ef.png",
    scale: 0.3,
  }),
});

const evaquationRain = new Style({
  image: new Icon({
    anchor: [0.5, 1],
    src: "assets/eh.png",
    scale: 0.3,
  }),
});

const evaquationLandslides = new Style({
  image: new Icon({
    anchor: [0.5, 1],
    src: "assets/el.png",
    scale: 0.3,
  }),
});

const evaquationLighting = new Style({
  image: new Icon({
    anchor: [0.5, 1],
    src: "assets/elh.png",
    scale: 0.3,
  }),
});

const evaquationMarine = new Style({
  image: new Icon({
    anchor: [0.5, 1],
    src: "assets/em.png",
    scale: 0.3,
  }),
});

const evaquationWind = new Style({
  image: new Icon({
    anchor: [0.5, 1],
    src: "assets/ew.png",
    scale: 0.3,
  }),
});

const watchFlood = new Style({
  image: new Icon({
    anchor: [0.5, 1],
    src: "assets/wf.png",
    scale: 0.3,
  }),
});

const watchRain = new Style({
  image: new Icon({
    anchor: [0.5, 1],
    src: "assets/wh.png",
    scale: 0.3,
  }),
});

const watchLandslides = new Style({
  image: new Icon({
    anchor: [0.5, 1],
    src: "assets/wl.png",
    scale: 0.3,
  }),
});

const watchLighting = new Style({
  image: new Icon({
    anchor: [0.5, 1],
    src: "assets/wlh.png",
    scale: 0.3,
  }),
});

const watchMarine = new Style({
  image: new Icon({
    anchor: [0.5, 1],
    src: "assets/wm.png",
    scale: 0.3,
  }),
});

const watchWind = new Style({
  image: new Icon({
    anchor: [0.5, 1],
    src: "assets/ww.png",
    scale: 0.3,
  }),
});

const tsunamiMarker = new Style({
  image: new Icon({
    anchor: [0.5, 1],
    src: "assets/tsunami_icon.png",
    scale: 0.3,
  }),
});

const iconEarlyWarningMap = new Map([
  [
    "3",
    new Map([
      ["LSW", evaquationLandslides],
      ["HRW", evaquationRain],
      ["FLW", evaquationFlood],
      ["TSM", tsunamiMarker],
      ["HWN", evaquationWind],
      ["SAN", evaquationMarine],
      ["LIG", evaquationLighting],
    ]),
  ],
  [
    "1",
    new Map([
      ["LSW", watchLandslides],
      ["HRW", watchRain],
      ["FLW", watchFlood],
      ["TSM", tsunamiMarker],
      ["HWN", watchWind],
      ["SAN", watchMarine],
      ["LIG", watchLighting],
    ]),
  ],
  [
    "2",
    new Map([
      ["LSW", amberLandslides],
      ["HRW", amberRain],
      ["FLW", amberFlood],
      ["TSM", tsunamiMarker],
      ["HWN", amberWind],
      ["SAN", amberMarine],
      ["LIG", amberLighting],
    ]),
  ],
]);

const adjustMarkerSize = (zoom: number): void => {
  const scaleFactor = zoom / 10; // Example: scale factor based on zoom level
  iconEarlyWarningMap.forEach((severityMap) => {
    severityMap.forEach((style) => {
      const icon = style.getImage();
      if (icon instanceof Icon && icon !== null) {
        icon.setScale(0.4 * scaleFactor); // Adjust scale based on zoom level
      }
    });
  });
};

map.on("moveend", () => {
  const zoom = map.getView().getZoom();
  if (zoom !== undefined) {
    adjustMarkerSize(zoom);
  }
});

let currentZoom = map.getView().getZoom();

map.getView().on("change:resolution", function () {
  const newZoom = map.getView().getZoom();

  if (typeof newZoom === "number" && newZoom !== currentZoom) {
    currentZoom = newZoom;

    map.getOverlays().forEach(function (overlay) {
      const element = overlay.getElement();
      if (element && element.tagName === "IMG") {
        const baseSize = 40;
        const scaleFactor = newZoom / 10;
        const newSize = baseSize * scaleFactor;
        element.style.width = `${newSize}px`;
        element.style.height = `${newSize}px`;
      }
    });
  }
});

const animationEarlyWarningMap = new Map([
  [
    "3",
    new Map([
      ["LSW", "assets/elg.gif"],
      ["HRW", "assets/ehg.gif"],
      ["FLW", "assets/efg.gif"],
      ["TSM", "assets/tsunami_icon.png"],
      ["HWN", "assets/ewg.gif"],
      ["SAN", "assets/emg.gif"],
      ["LIG", "assets/elhg.gif"],
    ]),
  ],
  [
    "1",
    new Map([
      ["LSW", "assets/wlg.gif"],
      ["HRW", "assets/whg.gif"],
      ["FLW", "assets/wfg.gif"],
      ["TSM", "assets/tsunami_icon.png"],
      ["HWN", "assets/wwg.gif"],
      ["SAN", "assets/wmg.gif"],
      ["LIG", "assets/wlhg.gif"],
    ]),
  ],
  [
    "2",
    new Map([
      ["LSW", "assets/alg.gif"],
      ["HRW", "assets/ahg.gif"],
      ["FLW", "assets/afg.gif"],
      ["TSM", "assets/tsunami_icon.png"],
      ["HWN", "assets/awg.gif"],
      ["SAN", "assets/amg.gif"],
      ["LIG", "assets/alhg.gif"],
    ]),
  ],
]);

const sensorEmpty = new Style({
  image: new Icon({
    anchor: [0.5, 1],
    src: "assets/tra3.png",
    scale: 0.1,
    opacity: 0.1,
  }),
});

type earlyWarningPropType = {
  id: number;
  title: string;
  passClickedEWSValue: (clicked: boolean) => void;
  menuOpen: boolean;
  sensorType: (value: string) => void;
  openModular: (value: string) => void;
  renderEWS: (value: boolean) => void;
};

export const openEwsWindowsMap = new Map<string, string>();
let openEwsTypeMap: Map<string, boolean> = new Map();
let clickedEWS: boolean = false;
let storedEarlyWarningFilter: earlyWarning[] = [];
let popupClick: boolean = false;
let storedEwsAll: earlyWarning[] = [];
export const EWSSidebarMap: Map<string, EwsSidebar> = new Map();

const ShowEarlyWarning = ({
  id,
  title,
  passClickedEWSValue,
  menuOpen,
  sensorType,
  openModular,
  renderEWS,
}: earlyWarningPropType) => {
  const [earlyWarningAll, setEarlyWarningAll] = useState<earlyWarning[]>([]);
  const [earlyWarningFilter, setEarlyWarningFilter] = useState<earlyWarning[]>(
    []
  );
  const [isClicked, setIsClicked] = useState<boolean>(true);
  let [isEyeOpen, setIsEyeOpen] = useState<boolean>(false);
  const [ewsType, setEwsType] = useState<string>("");
  const [currentLayer, setCurrentLayer] = useState<
    VectorLayer<VectorSource<Feature<Geometry>>>
  >(
    new VectorLayer({
      source: new VectorSource(),
    })
  );
  const [clickedPopup, setClickedPopup] = useState<boolean>(false);
  const {
    EWSOpenSidebarMap,
    setEWSOpenSidebarMap,
    removeFromEWSOpenSidebarMap,
  } = useEWSContext();
  const [_, setRender] = useState(false);
  const { setMarker } = useAllWeatherContext();
  const toggleSensorVisibility = () => {
    setRender((prevRender) => {
      const newRender = !prevRender;
      renderEWS(newRender);
      return newRender;
    });
  };

  const ewsTypeMap = new Map([
    ["Landslide Early Warning", "LSW"],
    ["Flood Early Warning", "FLW"],
    ["Heavy Rain Early Warning", "HRW"],
    ["High Wind Warning", "HWN"],
    ["Severe Lightning Early Waring", "LIG"],
    ["Marine Early Waring", "SAN"],
    ["Tsunami Early Waring", "TSM"],
  ]);

  // useEffect(() => {
  //   if (clickedString === "clickEws" && earlyWarningAll.length > 0) {
  //     // Toggle dropdown if conditions are met
  //     fetchData();

  //     // Process each warning in earlyWarningsFull
  //     earlyWarningAll.forEach((warning) => {
  //       const warningType = warning.w_type;
  //       const ewsKey = Array.from(ewsTypeMap.entries()).find(
  //         ([key, value]) => value === warningType
  //       )?.[0];

  //       if (ewsKey) {
  //         console.log(`Key for ${warningType} is: ${ewsKey}`);
  //         handleButtonClick(ewsKey);
  //         setClickedPopup(true);
  //       } else {
  //         console.log(`No matching key found for type: ${warningType}`);
  //       }
  //     });
  //   }
  // }, [clickedString, earlyWarningAll]);

  // eye click function
  const handleButtonClick = (ttl: string) => {
    setEwsType(ttl);
    setIsClicked((prevState) => !prevState);
    if (isEyeOpen === true) {
      setClickedPopup(true);
      popupClick = true;
      fetchData();
      setIsEyeOpen(false);
      openEwsTypeMap.set(ttl, true);
      loadTile(ttl, true);
      const mappedType = ewsTypeMap.get(ttl);
      if (mappedType) {
        removeOverlay(mappedType);
        setTimeout(() => {
          removeOverlay(mappedType);
        }, 500);
      }
    } else {
      setClickedPopup(true);
      popupClick = true;
      setIsEyeOpen(true);
      openEwsTypeMap.set(ttl, false);
      loadTile(ttl, false);
    }
  };

  const loadTile = (ewsType: string, checked: boolean) => {
    let url;
    if (ewsType === "Landslide Early Warning") {
      url = require("../../data/flw.geojson");
    } else if (ewsType === "Flood Early Warning") {
      url = require("../../data/ews.geojson");
    } else if (ewsType === "Heavy Rain Early Warning") {
      url = require("../../data/hrw.geojson");
    } else if (ewsType === "High Wind Warning") {
      // url = require("../../data/hwn.geojson");
    } else if (ewsType === "Severe Lightning Early Waring") {
      url = require("../../data/lig.geojson");
    }

    const vector = new VectorLayer({
      source: new VectorSource({
        url: url,
        format: new GeoJSON(),
      }),
      background: "transparent",
      style: {
        "fill-color": ["string", ["get", "COLOR"], "#eeeeee"],
      },
    });

    EWSLayerAdd(vector, checked, ewsType);
  };

  const removeOverlay = (key: string) => {
    const overlays = map.getOverlays().getArray();
    const overlaysToRemove = overlays.filter(
      (overlay) => overlay.getId() === key
    );
    overlaysToRemove.forEach((overlay) => {
      map.removeOverlay(overlay);
    });
  };

  const filterEws = (type: string, value: boolean) => {
    if (type === ewsType) {
      const mappedType = ewsTypeMap.get(type);
      if (mappedType) {
        if (clickedPopup === true) {
          if (!value) {
            let filteredData = storedEwsAll.filter(
              (incident) => incident.w_type === mappedType
            );
            setEarlyWarningFilter((prevState) => {
              const updatedFilter = [...prevState, ...filteredData];
              storedEarlyWarningFilter = [
                ...storedEarlyWarningFilter,
                ...filteredData.filter(
                  (incident) =>
                    !storedEarlyWarningFilter.some(
                      (storedIncident) =>
                        storedIncident.active_pcode === incident.active_pcode
                    )
                ),
              ];
              return updatedFilter;
            });
            setIsClicked(false);
          } else if (value) {
            // Remove from earlyWarningFilter and storedEarlyWarningFilter
            setEarlyWarningFilter((prevState) => {
              const updatedFilter = prevState.filter(
                (incident) => incident.w_type !== mappedType
              );
              // Update storedEarlyWarningFilter
              storedEarlyWarningFilter = storedEarlyWarningFilter.filter(
                (incident) => incident.w_type !== mappedType
              );
              return updatedFilter;
            });
            setIsClicked(false);
          }
        } else {
          let filteredData = storedEwsAll.filter(
            (incident) => incident.w_type === mappedType
          );
          setEarlyWarningFilter((prevState) => {
            const updatedFilter = [...prevState, ...filteredData];
            storedEarlyWarningFilter = [
              ...storedEarlyWarningFilter,
              ...filteredData.filter(
                (incident) =>
                  !storedEarlyWarningFilter.some(
                    (storedIncident) =>
                      storedIncident.active_pcode === incident.active_pcode
                  )
              ),
            ];
            return updatedFilter;
          });
          setIsClicked(false);
        }
      }
    }
  };

  //find load ews types
  useEffect(() => {
    if (menuOpen) {
      openEwsTypeMap.forEach((value, type) => {
        filterEws(type, value);
      });
      clickedEWS = Array.from(openEwsTypeMap.values()).every((value) => value);
      passClickedEWSValue(!clickedEWS);
    }
  }, [ewsType, isEyeOpen, menuOpen]);

  useEffect(() => {}, [isEyeOpen]);

  useEffect(() => {}, [isClicked]);

  useEffect(() => {}, [popupClick]);

  // useEffect(() => {}, [earlyWarningAll]);

  useEffect(() => {}, [storedEwsAll]);

  useEffect(() => {}, [earlyWarningFilter]);

  useEffect(() => {}, [storedEarlyWarningFilter]);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (storedEarlyWarningFilter.length > 0 && menuOpen) {
      setIsClicked(false);
      createMapWithMarkers(storedEarlyWarningFilter);
    } else if (storedEarlyWarningFilter.length === 0) {
      emptyMarkers(storedEarlyWarningFilter);
    }
  }, [storedEarlyWarningFilter, isClicked, menuOpen]);

  //when open after close once load data before close first time
  useEffect(() => {
    if (
      openEwsTypeMap.size > 0 &&
      clickedPopup === false &&
      menuOpen === true
    ) {
      removeMarkers();
      setEarlyWarningFilter(storedEarlyWarningFilter);
      const openKeys = findOpenedEWSKeys();

      if (openKeys.includes(title)) {
        setIsEyeOpen(true);
        setEwsType(title);
      }
      setIsClicked(false);
      createMapWithMarkers(storedEarlyWarningFilter);
    }
  }, [openEwsTypeMap, title, clickedPopup, isEyeOpen, ewsType, menuOpen]);

  useEffect(() => {
    openEwsTypeMap.forEach((value, key) => {
      if (key === "Landslide Early Warning" && value === true) {
        const entries = Array.from(EWSSidebarMap.values());
        entries.forEach((details, index) => {
          const { coordinates, active_pcode, w_name } = details;
          if (w_name === "Landslide Early Warning") {
            removeAnimation(active_pcode!);
          }
        });
      } else if (key === "Flood Early Warning" && value === true) {
        const entries = Array.from(EWSSidebarMap.values());
        entries.forEach((details, index) => {
          const { coordinates, active_pcode, w_name } = details;
          if (w_name === "Flood Early Warning") {
            removeAnimation(active_pcode!);
          }
        });
      } else if (key === "Heavy Rain Early Warning" && value === true) {
        const entries = Array.from(EWSSidebarMap.values());
        entries.forEach((details, index) => {
          const { coordinates, active_pcode, w_name } = details;
          if (w_name === "Heavy Rain Early Warning") {
            removeAnimation(active_pcode!);
          }
        });
      } else if (key === "High Wind Warning" && value === true) {
        const entries = Array.from(EWSSidebarMap.values());
        entries.forEach((details, index) => {
          const { coordinates, active_pcode, w_name } = details;
          if (w_name === "High Wind Warning") {
            removeAnimation(active_pcode!);
          }
        });
      } else if (key === "Severe Lightning Early Waring" && value === true) {
        const entries = Array.from(EWSSidebarMap.values());
        entries.forEach((details, index) => {
          const { coordinates, active_pcode, w_name } = details;
          if (w_name === "Severe Lightning Early Waring") {
            removeAnimation(active_pcode!);
          }
        });
      }
    });
  }, [openEwsTypeMap.entries()]);

  // to clicked type and duration remain when main window relaunch
  const findOpenedEWSKeys = () => {
    const closedKeys = Array.from(openEwsTypeMap.entries())
      .filter(([key, value]) => !value) // Filter for keys where the value is false
      .map(([key]) => key); // Map to get only the keys
    return closedKeys;
  };

  const removeMarkers = () => {
    if (currentLayer) {
      map.removeLayer(currentLayer);
    }

    setEarlyWarningFilter([]);
    storedEarlyWarningFilter = [];
  };

  const handleClose = (incidentId: string) => {
    openEwsWindowsMap.set(incidentId, "close");
    removeFromEWSOpenSidebarMap(incidentId);
    if (EWSSidebarMap.has(incidentId)) {
      EWSSidebarMap.delete(incidentId);
    }
    const entries = Array.from(EWSOpenSidebarMap.values());
    const lastEntryIndex = entries.length - 1;
    entries.forEach((details, index) => {
      const { coordinates, active_pcode } = details;
      if (coordinates) {
        removeOverlay(active_pcode!);
        if (index === lastEntryIndex) {
          // Handle last entry
          addOverlayClickItemLast(active_pcode!, coordinates);
        } else {
          // Handle all other entries
          addOverlayClickItem(active_pcode!, coordinates);
        }
      }
    });

    if (layerButtonValue === "hawk eye") {
      const entries = Array.from(EWSSidebarMap.values());
      const lastEntryIndex = entries.length - 1;
      entries.forEach((details, index) => {
        const { coordinates, active_pcode } = details;
        if (coordinates) {
          removeOverlay(active_pcode!);
          if (index === lastEntryIndex) {
            // Handle last entry
            addOverlayClickItemLast(active_pcode!, coordinates);
          } else {
            // Handle all other entries
            addOverlayClickItem(active_pcode!, coordinates);
          }
        }
      });
    }
  };

  //fetch data
  const fetchData = async () => {
    const EARLY_WARNING_TEST_URL = process.env.REACT_APP_EARLY_WARNING_TEST_URL;
    const EARLY_WARNING_URL = process.env.REACT_APP_EARLY_WARNING_URL;
    const gisArray = process.env.REACT_APP_GIS_ARRAY?.split(",") || [];
    const queryString = `arealist=${gisArray.join(",")}`;

    const EARLY_WARNING_MALDIVES_TEST_URL =
      process.env.REACT_APP_MALDIVES_EARLY_WARNING_TEST_URL;
    const EARLY_WARNING_MALDIVES_URL =
      process.env.REACT_APP_MALDIVES_EARLY_WARNING_URL;
    const gisArrayMaldives =
      process.env.REACT_APP_GIS_ARRAY_MALDIVES?.split(",") || [];
    const queryStringMaldives = `arealist=${gisArrayMaldives.join(",")}`;

    try {
      let url = `${EARLY_WARNING_TEST_URL}${queryString}`;
      //let url = `${EARLY_WARNING_URL}${queryString}`;

      // let url = `${EARLY_WARNING_MALDIVES_TEST_URL}${queryStringMaldives}`;
      //let url = `${EARLY_WARNING_MALDIVES_URL}${queryStringMaldives}`;

      const response = await fetch(url);
      const responseData = await response.json();

      if (Array.isArray(responseData)) {
        const data: earlyWarning[] = responseData;
        setEarlyWarningAll(data);
        createOpenPopupmap(data);
        storedEwsAll = data;
      } else {
        console.error("Invalid response data format:", responseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const createOpenPopupmap = (data: earlyWarning[]) => {
    data.forEach((incident) => {
      openEwsWindowsMap.set(incident.active_pcode, "close");
    });
  };

  const emptyMarkers = async (flteredIncidents: earlyWarning[]) => {
    if (currentLayer) {
      map.removeLayer(currentLayer);
    }
    const vectorSource = new VectorSource();
    const vectorLayer = new VectorLayer({
      source: vectorSource,
    });
    setCurrentLayer(vectorLayer);
    getLayerName("ews", true);
  };

  const createMapWithMarkers = async (earlyWarningFil: earlyWarning[]) => {
    if (currentLayer) {
      map.removeLayer(currentLayer);
    }

    const vectorSource = new VectorSource();
    const vectorLayer = new VectorLayer({
      source: vectorSource,
    });

    const sensorLevels = await Promise.all(
      earlyWarningFil.map(async (marker) => {
        return { marker };
      })
    );

    const newFeatures = sensorLevels.map(({ marker }) => {
      const point = new Point(fromLonLat([marker.lon, marker.lat]));

      const feature = new Feature({
        geometry: point,
        id: marker.w_id,
        adm4_en: marker.adm4_en,
        end_time: marker.end_time,
        active_pcode: marker.active_pcode,
        s_desc: marker.s_desc,
        severity_index: marker.severity_index,
        issued_time: marker.issued_time,
        severity: marker.severity,
        adm4_pcode: marker.adm4_pcode,
        adm3_pcode: marker.adm3_pcode,
        adm3_en: marker.adm3_en,
        adm2_pcode: marker.adm2_pcode,
        adm2_en: marker.adm2_en,
        active_alevel: marker.active_alevel,
        en_desc: marker.en_desc,
        validityPeriod: marker.validityPeriod,
        w_status: marker.w_status,
        w_desc: marker.w_desc,
        w_name: marker.w_name,
        w_type: marker.w_type,
        adm1_en: marker.adm1_en,
      });

      const issuedTime = new Date(marker.issued_time);
      const oneDayLater = new Date(issuedTime); // Create a new Date object to avoid modifying the original
      oneDayLater.setDate(oneDayLater.getDate() + 1);

      const cutoffDate = new Date("2024-05-20");
      const today = new Date();

      let style;
      if (issuedTime > cutoffDate) {
        if (marker.severity_index && marker.w_type) {
          const severitygifMap = animationEarlyWarningMap.get(
            marker.severity_index.toString()
          );
          if (severitygifMap) {
            const gifLink = severitygifMap.get(marker.w_type);
            const overlayCoordinateMap = new Map();

            if (gifLink) {
              const coordinates = point.getCoordinates();
              const coordKey = coordinates.toString(); // Create a unique key for the coordinates

              // Check if an overlay already exists at this coordinate
              if (overlayCoordinateMap.has(coordKey)) {
                // If an overlay exists, remove it from the map
                const existingOverlay = overlayCoordinateMap.get(coordKey);
                map.removeOverlay(existingOverlay);
              }

              // Create the gif element
              const gifElement = document.createElement("img");
              gifElement.src = gifLink;
              gifElement.style.width = "30px";

              // Create a new overlay
              const overlay = new Overlay({
                id: marker.w_type,
                position: coordinates,
                positioning: "center-center",
                element: gifElement,
                stopEvent: false,
              });

              // Add overlay to the map
              map.addOverlay(overlay);
              style = sensorEmpty;

              // Store the new overlay in the coordinate map
              overlayCoordinateMap.set(coordKey, overlay);
            }
          }
        }
      } else if (issuedTime <= cutoffDate) {
        // } else if (oneDayLater <= today) {
        if (marker.severity_index && marker.w_type) {
          const severityMap = iconEarlyWarningMap.get(
            marker.severity_index.toString()
          );

          if (severityMap) {
            style = severityMap.get(marker.w_type);
          }
        }
        if (!style) {
          style = watchLandslides;
        }
      }

      feature.setStyle(style);

      return feature;
    });

    vectorSource.addFeatures(newFeatures);
    setCurrentLayer(vectorLayer);

    map.on("click", (evt) => {
      const feature = map.forEachFeatureAtPixel(evt.pixel, (feature) => {
        return feature;
      });
      if (feature) {
        setMarker("clickMarker");
      }
      const value = feature
        ? openEwsWindowsMap.get(feature.get("active_pcode"))
        : undefined;

      if (feature && value === "close") {
        const geometry = feature.getGeometry() as Point;
        const coordinates = geometry.getCoordinates();
        const sensorId = feature.get("id");
        const adm4_en = feature.get("adm4_en");
        const end_time = feature.get("end_time");
        const active_pcode = feature.get("active_pcode");
        const s_desc = feature.get("s_desc");
        const severity_index = feature.get("severity_index");
        const severity = feature.get("severity");
        const adm4_pcode = feature.get("adm4_pcode");
        const adm3_pcode = feature.get("adm3_pcode");
        const adm3_en = feature.get("adm3_en");
        const adm2_pcode = feature.get("adm2_pcode");
        const adm2_en = feature.get("adm2_en");
        const active_alevel = feature.get("active_alevel");
        const en_desc = feature.get("en_desc");
        const validityPeriod = feature.get("validityPeriod");
        const w_status = feature.get("w_status");
        const issued_time = feature.get("issued_time");
        const w_desc = feature.get("w_desc");
        const w_name = feature.get("w_name");
        const w_type = feature.get("w_type");
        const adm1_en = feature.get("adm1_en");
        if (w_desc) {
          openEwsWindowsMap.set(active_pcode, "open");
          // LocationMarkerPopup("earlywarning");
          showPopup(
            sensorId,
            coordinates,
            adm4_en,
            active_pcode,
            end_time,
            s_desc,
            severity_index,
            severity,
            adm4_pcode,
            adm3_pcode,
            adm3_en,
            adm2_pcode,
            adm2_en,
            active_alevel,
            en_desc,
            validityPeriod,
            issued_time,
            w_status,
            w_desc,
            w_name,
            w_type,
            adm1_en
          );
          if (layerButtonValue === "hawk eye") {
            const entries = Array.from(EWSSidebarMap.values());
            const lastEntryIndex = entries.length - 1;
            entries.forEach((details, index) => {
              const { coordinates, active_pcode } = details;
              if (coordinates) {
                removeAnimation(active_pcode!);
                if (index === lastEntryIndex) {
                  // Handle last entry
                  addOverlayClickItemLast(active_pcode!, coordinates);
                } else {
                  // Handle all other entries
                  addOverlayClickItem(active_pcode!, coordinates);
                }
              }
            });
          }
        }
      }
      setTimeout(() => {
        setMarker("notClickMarker");
      }, 500);
    });
    EWSLayerAdd(vectorLayer, isClicked, "ews");
  };

  useEffect(() => {
    const entries = Array.from(EWSOpenSidebarMap.values());
    const lastEntryIndex = entries.length - 1;
    entries.forEach((details, index) => {
      const { coordinates, active_pcode } = details;
      if (coordinates) {
        removeAnimation(active_pcode!);
        if (index === lastEntryIndex) {
          // Handle last entry
          addOverlayClickItemLast(active_pcode!, coordinates);
        } else {
          // Handle all other entries
          addOverlayClickItem(active_pcode!, coordinates);
        }
      }
    });
  }, [EWSOpenSidebarMap.size]);

  const removeAnimation = (key: string) => {
    const overlays = map.getOverlays().getArray();
    const overlaysToRemove = overlays.filter(
      (overlay) => overlay.getId() === key
    );
    overlaysToRemove.forEach((overlay) => {
      map.removeOverlay(overlay);
    });
  };

  const addOverlayClickItem = (id: string, coordinates: Coordinate) => {
    const markerElement = document.createElement("div");
    markerElement.className = "location-dot animate";

    const ringElement = document.createElement("div");
    ringElement.className = "location-dot-ring";

    markerElement.appendChild(ringElement);
    const overlay = new Overlay({
      id: id,
      position: coordinates,
      positioning: "center-center",
      element: markerElement,
      stopEvent: false,
    });
    map.addOverlay(overlay);
  };

  const addOverlayClickItemLast = (id: string, coordinates: Coordinate) => {
    const markerElement = document.createElement("div");
    markerElement.className = "locationlast-dot animate";

    const ringElement = document.createElement("div");
    ringElement.className = "locationlast-dot-ring";

    markerElement.appendChild(ringElement);
    const overlay = new Overlay({
      id: id,
      position: coordinates,
      positioning: "center-center",
      element: markerElement,
      stopEvent: false,
    });
    map.addOverlay(overlay);
  };

  const showPopup = (
    sensorId: string | null,
    coordinates: Coordinate | null,
    adm4_en: string | null,
    active_pcode: string | null,
    end_time: string | null,
    s_desc: string | null,
    severity_index: string | null,
    severity: string | null,
    adm4_pcode: string | null,
    adm3_pcode: string | null,
    adm3_en: string | null,
    adm2_pcode: string | null,
    adm2_en: string | null,
    active_alevel: string | null,
    en_desc: string | null,
    validityPeriod: string | null,
    issued_time: string | null,
    w_status: string | null,
    w_desc: string | null,
    w_name: string | null,
    w_type: string | null,
    adm1_en: string | null
  ) => {
    toggleSensorVisibility();
    sensorType("ewsLocation");
    if (layerButtonValue === "modular") {
      const entries = Array.from(airQualityMap.values());
      entries.forEach((details, index) => {
        const { coordinates, sensorId } = details;
        if (coordinates) {
          removeOverlay(sensorId!);
          openWindowsAirQualityMap.set(sensorId!, "close");
        }
      });
      const entriesHz = Array.from(HzSidebarMap.values());
      entriesHz.forEach((details, index) => {
        const { coordinates, sensorId } = details;
        if (coordinates) {
          removeOverlay(sensorId!);
          openWindowsHzMap.set(sensorId!, "close");
        }
      });
      const entriesriver = Array.from(riverMap.values());
      entriesriver.forEach((details, index) => {
        const { coordinates, sensorId } = details;
        if (coordinates) {
          removeOverlay(sensorId!);
          openWindowsMapRiver.set(sensorId!, "close");
        }
      });
      const entriesRain = Array.from(rainfallMap.values());
      entriesRain.forEach((details, index) => {
        const { coordinates, sensorId } = details;
        if (coordinates) {
          removeOverlay(sensorId!);
          openWindowsRainfallMap.set(sensorId!, "close");
        }
      });
    }
    if (
      sensorId !== null &&
      coordinates !== null &&
      adm4_en !== null &&
      active_pcode !== null &&
      end_time !== null &&
      s_desc !== null &&
      severity_index !== null &&
      severity !== null &&
      adm4_pcode !== null &&
      adm3_pcode !== null &&
      adm3_en !== null &&
      adm2_pcode !== null &&
      adm2_en !== null &&
      end_time !== null &&
      active_alevel !== null &&
      en_desc !== null &&
      validityPeriod !== null &&
      issued_time !== null &&
      w_status !== null &&
      w_desc !== null &&
      w_name !== null &&
      w_type !== null &&
      adm1_en !== null
    ) {
      const popupElement = document.createElement("ews");
      if (layerButtonValue === "hawk eye") {
        ReactDOM.render(
          <EarlyWarningPopup
            warningId={sensorId}
            coordinates={coordinates}
            adm4_en={adm4_en}
            active_pcode={active_pcode}
            end_time={end_time}
            s_desc={s_desc}
            severity_index={severity_index}
            severity={severity}
            adm4_pcode={adm4_pcode}
            adm3_pcode={adm3_pcode}
            adm3_en={adm3_en}
            adm2_pcode={adm2_pcode}
            adm2_en={adm2_en}
            active_alevel={active_alevel}
            en_desc={en_desc}
            validityPeriod={validityPeriod}
            issued_time={issued_time}
            w_status={w_status}
            w_desc={w_desc}
            w_name={w_name}
            w_type={w_type}
            onClose={handleClose}
            adm1_en={adm1_en}
          />,

          popupElement
        );
        const overlay = new Overlay({
          element: popupElement,
          autoPan: {
            animation: {
              duration: 250,
            },
          },
        });
        overlay.setPosition(coordinates);
        map.addOverlay(overlay);
        const newEWS: EwsSidebar = {
          sensorId: sensorId,
          coordinates: coordinates,
          adm4_en: adm4_en,
          active_pcode: active_pcode,
          end_time: end_time,
          s_desc: s_desc,
          severity_index: severity_index,
          severity: severity,
          adm4_pcode: adm4_pcode,
          adm3_pcode: adm3_pcode,
          adm3_en: adm3_en,
          adm2_pcode: adm2_pcode,
          adm2_en: adm2_en,
          active_alevel: active_alevel,
          en_desc: en_desc,
          validityPeriod: validityPeriod,
          issued_time: issued_time,
          w_status: w_status,
          w_desc: w_desc,
          w_name: w_name,
          w_type: w_type,
          adm1_en: adm1_en,
        };
        setEWSOpenSidebarMap(newEWS.active_pcode!, newEWS);
        EWSSidebarMap.set(newEWS.active_pcode!, newEWS);
      } else if (layerButtonValue === "modular") {
        const newEWS: EwsSidebar = {
          sensorId: sensorId,
          coordinates: coordinates,
          adm4_en: adm4_en,
          active_pcode: active_pcode,
          end_time: end_time,
          s_desc: s_desc,
          severity_index: severity_index,
          severity: severity,
          adm4_pcode: adm4_pcode,
          adm3_pcode: adm3_pcode,
          adm3_en: adm3_en,
          adm2_pcode: adm2_pcode,
          adm2_en: adm2_en,
          active_alevel: active_alevel,
          en_desc: en_desc,
          validityPeriod: validityPeriod,
          issued_time: issued_time,
          w_status: w_status,
          w_desc: w_desc,
          w_name: w_name,
          w_type: w_type,
          adm1_en: adm1_en,
        };
        openModular("modularOpened");
        setEWSOpenSidebarMap(newEWS.active_pcode!, newEWS);
        EWSSidebarMap.set(newEWS.active_pcode!, newEWS);
      }
    }
  };
  return (
    <div key={id} className={styles.overlayItem}>
      <div className={styles.header}>
        <div className={styles.headerCell} style={{ gridArea: `a` }}>
          <img
            src={
              isEyeOpen
                ? require("../../assets/eye-open.png")
                : require("../../assets/eye-close.png")
            }
            alt=""
            onClick={() => {
              handleButtonClick(title);
              setClickedPopup(true);
            }}
            onTouchStart={() => {
              handleButtonClick(title);
              setClickedPopup(true);
            }}
          />
        </div>
        <div className={styles.headerCell} style={{ gridArea: `b` }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row", // Set default direction as row
              justifyContent: "flex-start", // Aligns content to the start of the main axis (row)
              alignItems: "center", // Centers content along the cross axis (column)
              fontSize: "0.8rem",
              width: "100%",
            }}
          >
            {title}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShowEarlyWarning;
